import { useAuth } from '../../contexts/AuthContext';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useUserApi } from '../../hooks/useUserApi';

export const useLoginService = () => {
  const [modal, setModal] = useState(null);
  const navigate = useNavigate();
  const { loginWithMicrosoftFn } = useAuth();
  const { loginWithKeycloak, loading: keycloakLoading } = useUserApi();

  const handleMicrosoftLogin = async () => {
    const result = await loginWithMicrosoftFn();
    if (result.success) {
      setModal({
        type: "success",
        title: "Login Successful",
        message: "Welcome! You will be redirected to the dashboard.",
      });
      setTimeout(() => {
        setModal(null);
        navigate("/timesheet");
      }, 2000);
    } else {
      setModal({
        type: "error",
        title: "Login Failed",
        message: result.error || "Microsoft login failed. Please try again.",
      });
    }
  };

  const handleKeycloakLogin = async (username, password) => {
    const result = await loginWithKeycloak(username, password);
    if (result.success) {
      setModal({
        type: "success",
        title: "Login Successful",
        message: "Welcome! You will be redirected to the dashboard.",
      });
      setTimeout(() => {
        setModal(null);
        navigate("/timesheet");
      }, 2000);
    } else {
      setModal({
        type: "error",
        title: "Login Failed",
        message: result.error || "Login failed. Please try again.",
      });
    }
  };

  const handleCloseModal = () => {
    setModal(null);
    if (modal?.type === "success") {
      navigate("/dashboard");
    }
  };

  return {
    modal,
    handleMicrosoftLogin,
    handleKeycloakLogin,
    handleCloseModal,
    keycloakLoading,
  };
}; 